import { lazy, Suspense } from "react";
import { AuthSkeleton } from "../customs/skeleton/main";
const Main = lazy(() => import("../components/singleSignOn/main"));

const SingleSignOn = () => {
  return (
      <Suspense fallback={<AuthSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default SingleSignOn;
